export default "__VITE_ASSET__43d20287__"